import { getTemplateAgeLabel } from './resolve-template';
import TemplateOptionCard from './TemplateOptionCard';
import { ANAMNESIS_TEMPLATES, type AnamnesisTemplateId } from './templates';

type Props = {
    onSelect: (templateId: AnamnesisTemplateId) => void;
};

/** Starting points for an anamnesis — the model name, its age range, and its sections on demand. */
export default function TemplateGallery({ onSelect }: Props) {
    return (
        <div className="grid gap-3 sm:grid-cols-2">
            {ANAMNESIS_TEMPLATES.map((template) => (
                <TemplateOptionCard
                    key={template.id}
                    name={template.name}
                    meta={[getTemplateAgeLabel(template.id) ?? 'Página livre']}
                    sections={template.sections.map((section) => section.title)}
                    onSelect={() => onSelect(template.id)}
                />
            ))}
        </div>
    );
}
